import { CheckUtils, UserCalendarOptionsVoData, UserProfileVoData, UserResolverVoData, UserTypeOptionsVoData, UserVoData, UserWorkTimerVoData } from "../..";
import { DateConverter } from "./date-converter";
var UsersConverter = /** @class */ (function () {
    function UsersConverter() {
    }
    UsersConverter.convertToUserVoData = function (user, target) {
        if (CheckUtils.isEmpty(user))
            return null;
        var result = (CheckUtils.isEmpty(target)) ? new UserVoData(user.userId, user.category) : target;
        result.type = user.type;
        this.convertToUserProfileVoData(user, result.profile);
        return result;
    };
    UsersConverter.convertToUserProfileVoData = function (user, target) {
        if (CheckUtils.isEmpty(user))
            return null;
        var result = (CheckUtils.isEmpty(target)) ? new UserProfileVoData() : target;
        result.displayName = user.displayName;
        result.photoUrl = user.photoUrl;
        result.color = user.color;
        result.pictureKey = user.pictureKey;
        return result;
    };
    UsersConverter.convertToUserCalendarOptionsVoData = function (userCalendarOptions, target) {
        if (CheckUtils.isEmpty(userCalendarOptions))
            return null;
        var result = (CheckUtils.isEmpty(target)) ? new UserCalendarOptionsVoData(userCalendarOptions.id) : target;
        result.publicICal = userCalendarOptions.publicICal;
        return result;
    };
    UsersConverter.convertToUserWorkTimerData = function (userWorkTimer, target) {
        if (CheckUtils.isEmpty(userWorkTimer))
            return null;
        var result = (CheckUtils.isEmpty(target)) ? new UserWorkTimerVoData(userWorkTimer.id) : target;
        result.itemId = userWorkTimer.itemId;
        result.amountOfWork = userWorkTimer.amountOfWork;
        result.startCurrentTimer = DateConverter.convertToDate(userWorkTimer.startCurrentTimer);
        result.startDate = DateConverter.convertToDate(userWorkTimer.startDate);
        return result;
    };
    UsersConverter.convertToUserResolverVoData = function (userResolver) {
        if (CheckUtils.isEmpty(userResolver))
            return null;
        return new UserResolverVoData(userResolver.userId, userResolver.jabberId);
    };
    UsersConverter.convertToTypeOptionsVoDataArray = function (userTypOptionsApiDataArray) {
        var userTyOpVoArray = [];
        for (var _i = 0, userTypOptionsApiDataArray_1 = userTypOptionsApiDataArray; _i < userTypOptionsApiDataArray_1.length; _i++) {
            var userTypeOp = userTypOptionsApiDataArray_1[_i];
            userTyOpVoArray.push(this.convertToUserTypeOptionsVoData(userTypeOp));
        }
        return userTyOpVoArray;
    };
    UsersConverter.convertToUserTypeOptionsVoData = function (userTypOptions) {
        var userTyOpVo = new UserTypeOptionsVoData(userTypOptions.name);
        userTyOpVo.userType = userTypOptions.userType;
        userTyOpVo.iconStyleName = userTypOptions.iconStyleName;
        userTyOpVo.iconColor = userTypOptions.iconColor;
        return userTyOpVo;
    };
    return UsersConverter;
}());
export { UsersConverter };
//# sourceMappingURL=users-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/users-converter.js
// module id = 973
// module chunks = 14